export default __webpack_public_path__ + "static/menu-main-04a64a245f3672a6cd377d948ef71289.jpg";